import axios from 'axios'

let idToken = ''

const storedUser = JSON.parse(localStorage.getItem('USER'))

if (storedUser != null && storedUser.signInUserSession != null) {
  idToken = storedUser.signInUserSession.idToken.jwtToken
}

axios.defaults.headers.common = {
  'Authorization': 'Bearer ' + idToken
}
const $axios = axios.create({})

export default $axios
